// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__OtBFT","title":"styles_title__e5dw6"};